import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React from 'react';
import './index.css';
import Home from './pages/Home';
import Rooms from './pages/Rooms';
import Restaurant from './pages/Restaurant';
import NavBar from './components/NavBar';
import FooterBar from './components/FooterBar';
import WhatsAppButton from './components/WhatsappButton';

function App() {
  return (
    <div className="app-container">
      <Router>
        <NavBar />
        <main className="content">
          <Routes>
            <Route path="/" element={
              <>
                <Home />
              </>
            } />
            <Route path="/rooms" element={<Rooms />} />
            <Route path="/restaurant" element={<Restaurant />} />
          </Routes>
        </main>
        <WhatsAppButton />
        <FooterBar />
      </Router>
    </div>
  );
}

export default App;
